/**
 * Static cover blocks, built from an arena's obstacle list so the visuals match
 * the sim's collision exactly. Block both movement and projectiles.
 */
import { MeshBuilder } from "@babylonjs/core/Meshes/meshBuilder.js";
import { StandardMaterial } from "@babylonjs/core/Materials/standardMaterial.js";
import { Color3 } from "@babylonjs/core/Maths/math.color.js";
import type { Scene } from "@babylonjs/core/scene.js";
import type { Aabb } from "@allstars/shared";

const HEIGHT = 1.6;

export const createObstacles = (scene: Scene, obstacles: readonly Aabb[]): void => {
  const mat = new StandardMaterial("obstacleMat", scene);
  mat.diffuseColor = new Color3(0.3, 0.34, 0.44);
  mat.specularColor = new Color3(0.06, 0.06, 0.06);

  obstacles.forEach((ob, i) => {
    const width = ob.max.x - ob.min.x;
    const depth = ob.max.y - ob.min.y;
    const box = MeshBuilder.CreateBox(`obstacle-${i}`, { width, height: HEIGHT, depth }, scene);
    box.position.set((ob.min.x + ob.max.x) / 2, HEIGHT / 2, (ob.min.y + ob.max.y) / 2);
    box.material = mat;
  });
};
